import { render, staticRenderFns } from "./carrusel.vue?vue&type=template&id=4e674183&"
import script from "./carrusel.vue?vue&type=script&lang=js&"
export * from "./carrusel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports